/**
 * #38 · Módulo de productos. Contrato en `routes/module.ts`.
 *
 * Sin `minimumRole`: el catálogo lo lee un `viewer` (`GET /api/v1/products`
 * pide `viewer`). Escribir exige `analyst` y borrar `admin`, y eso se resuelve
 * escondiendo los botones — no montando o no montando la pantalla.
 */
import type { ModuleRoutes } from '../module';
import { ProductDetailPage } from './ProductDetailPage';
import { ProductsPage } from './ProductsPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'products',
  routes: [
    { path: '', element: <ProductsPage /> },
    { path: ':productId', element: <ProductDetailPage /> },
  ],
};
